import type { ReactNode } from 'react';
import { Button, Stack, Text, Title } from '@mantine/core';

interface Props {
  icon: ReactNode;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function EmptyState({ icon, title, description, actionLabel, onAction }: Props) {
  return (
    <Stack align="center" gap="sm" py={48}>
      <div className="grid h-14 w-14 place-items-center rounded-full bg-[var(--wheels-bg)] text-[var(--wheels-ink-muted)]">
        {icon}
      </div>
      <Title order={4} c="var(--wheels-ink-strong)">
        {title}
      </Title>
      {description && (
        <Text c="var(--wheels-ink-muted)" maw={420} ta="center">
          {description}
        </Text>
      )}
      {actionLabel && onAction && (
        <Button onClick={onAction} mt="sm">
          {actionLabel}
        </Button>
      )}
    </Stack>
  );
}
